/* Chapters Book Bar site scripts, ported from the static prototype */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Bookshop.org live list renderer ---------- */
  // render bookshop.org lists natively: fetch the widget endpoint (it allows CORS),
  // parse out the books, and rebuild them in our own markup so site styles apply
  document.querySelectorAll('.list-embed[data-list-slug]').forEach(function (box) {
    var slug = box.getAttribute('data-list-slug');
    var listUrl = 'https://uk.bookshop.org/lists/' + slug;
    fetch('https://uk.bookshop.org/widgets/list/' + slug)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var covers = doc.querySelectorAll('a.cover');
        if (!covers.length) throw new Error('unexpected markup');

        // title: prefer the h1 link, fall back to any h1 text, then the slug itself
        var srcH1 = doc.querySelector('.list-header h1') || doc.querySelector('h1');
        var titleText = srcH1 ? srcH1.textContent.trim() : '';
        if (!titleText) titleText = slug.replace(/-/g, ' ');
        var header = document.createElement('div');
        header.className = 'list-header';
        var h1 = document.createElement('h1');
        var titleA = document.createElement('a');
        titleA.target = '_blank';
        titleA.rel = 'noopener';
        titleA.href = listUrl;
        titleA.textContent = titleText;
        h1.appendChild(titleA);
        header.appendChild(h1);

        var items = document.createElement('div');
        items.className = 'items';
        covers.forEach(function (c) {
          var srcImg = c.querySelector('img');
          if (!srcImg) return;
          var a = document.createElement('a');
          a.className = 'cover';
          a.target = '_blank';
          a.rel = 'noopener';
          a.href = c.getAttribute('href');
          var wrap = document.createElement('div');
          wrap.className = 'product-image';
          var img = document.createElement('img');
          img.src = srcImg.getAttribute('src');
          img.alt = srcImg.getAttribute('alt') || '';
          img.loading = 'lazy';
          wrap.appendChild(img);
          a.appendChild(wrap);
          items.appendChild(a);
        });

        var viewAll = document.createElement('div');
        viewAll.className = 'view-all-container';
        var btn = document.createElement('a');
        btn.className = 'button view-all';
        btn.target = '_blank';
        btn.rel = 'noopener';
        btn.href = listUrl;
        btn.textContent = 'View All on Bookshop.org (' + items.children.length + ')';
        viewAll.appendChild(btn);

        // settings, Shopify-style: title on/off via data attribute
        if (box.getAttribute('data-show-title') === 'false') {
          box.replaceChildren(items, viewAll);
        } else {
          box.replaceChildren(header, items, viewAll);
        }

        // strip layout starts centred on the middle book (once covers have sized themselves)
        if (!box.classList.contains('list-embed-grid')) {
          var imgs = Array.prototype.slice.call(items.querySelectorAll('img'));
          Promise.all(imgs.map(function (i) { return i.decode ? i.decode().catch(function () {}) : Promise.resolve(); }))
            .then(function () {
              var mid = items.children[Math.floor(items.children.length / 2)];
              if (mid) items.scrollLeft = mid.offsetLeft - (items.clientWidth - mid.clientWidth) / 2;
            });
        }
      })
      .catch(function () {
        // fallback: plain link to the list
        var viewAll = document.createElement('div');
        viewAll.className = 'view-all-container';
        var btn = document.createElement('a');
        btn.className = 'button view-all';
        btn.target = '_blank';
        btn.rel = 'noopener';
        btn.href = listUrl;
        btn.textContent = 'See the List on Bookshop.org';
        viewAll.appendChild(btn);
        box.replaceChildren(viewAll);
      });
  });

  /* ---------- Book marquee ---------- */
  // duplicate the shelf once so the marquee loops seamlessly
  function duplicateShelf(shelf) {
    Array.from(shelf.children).forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      shelf.appendChild(clone);
    });
  }

  // bookshop.org alt texts carry subtitle cruft after a colon or semicolon
  function cleanBookTitle(raw) {
    return (raw || '').split(/[:;]/)[0].trim();
  }

  // auto-drift a real scroll container and wrap at the halfway point, so the
  // loop is endless but the user can also scroll it manually at any time
  function initMarqueeScroll(carousel, shelf) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wrap = 0;
    var speed = 0; // px per second
    function measure() {
      var gap = parseFloat(getComputedStyle(shelf).columnGap) || 0;
      wrap = (shelf.scrollWidth + gap) / 2;
      speed = wrap / 45; // one full set every 45 seconds
    }
    measure();
    shelf.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('load', measure);
    });
    window.addEventListener('resize', measure);

    var paused = false;
    var idleTimer = null;
    function hold() { paused = true; clearTimeout(idleTimer); }
    function release(delay) {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { paused = false; }, delay);
    }
    carousel.addEventListener('pointerenter', hold);
    carousel.addEventListener('pointerleave', function () { release(800); });
    carousel.addEventListener('touchstart', hold, { passive: true });
    carousel.addEventListener('touchend', function () { release(2500); }, { passive: true });
    carousel.addEventListener('focusin', hold);
    carousel.addEventListener('focusout', function () { release(800); });
    carousel.addEventListener('wheel', function () { hold(); release(2500); }, { passive: true });
    carousel.addEventListener('scroll', function () {
      if (wrap > 0 && carousel.scrollLeft >= wrap) carousel.scrollLeft -= wrap;
    }, { passive: true });

    if (reduced) return; // still manually scrollable, just no auto-drift
    var last = null;
    function tick(ts) {
      if (last === null) last = ts;
      var dt = (ts - last) / 1000;
      last = ts;
      if (!paused && wrap > 0 && dt < 0.5) carousel.scrollLeft += speed * dt;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  // build the marquee from our live bookshop.org list: fetch the widget endpoint
  // (it allows CORS), parse out the books, and rebuild them in our own markup
  document.querySelectorAll('.shelf[data-list-slug]').forEach(function (shelf) {
    var slug = shelf.getAttribute('data-list-slug');
    var listUrl = 'https://uk.bookshop.org/lists/' + slug;
    fetch('https://uk.bookshop.org/widgets/list/' + slug)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var covers = doc.querySelectorAll('a.cover');
        if (!covers.length) throw new Error('unexpected markup');
        shelf.innerHTML = ''; // clear the skeleton placeholders
        covers.forEach(function (c) {
          var srcImg = c.querySelector('img');
          if (!srcImg) return;
          var li = document.createElement('li');
          li.className = 'book';
          var a = document.createElement('a');
          a.target = '_blank';
          a.rel = 'noopener';
          a.href = c.getAttribute('href');
          var coverSpan = document.createElement('span');
          coverSpan.className = 'book-cover';
          var img = document.createElement('img');
          img.src = srcImg.getAttribute('src');
          img.alt = cleanBookTitle(srcImg.getAttribute('alt'));
          img.loading = 'lazy';
          coverSpan.appendChild(img);
          var title = document.createElement('span');
          title.className = 'book-title';
          title.textContent = cleanBookTitle(srcImg.getAttribute('alt'));
          a.appendChild(coverSpan);
          a.appendChild(title);
          li.appendChild(a);
          shelf.appendChild(li);
        });
        duplicateShelf(shelf); // after items exist, so the loop stays seamless
        var carousel = shelf.closest('.shelf-carousel') || shelf.parentElement;
        initMarqueeScroll(carousel, shelf);
      })
      .catch(function () {
        // fallback: clear the skeleton and just link to the list
        shelf.innerHTML = '';
        var li = document.createElement('li');
        li.className = 'book';
        li.style.flexBasis = 'auto';
        var a = document.createElement('a');
        a.target = '_blank';
        a.rel = 'noopener';
        a.href = listUrl;
        a.textContent = 'See What We Are Recommending on Bookshop.org';
        li.appendChild(a);
        shelf.appendChild(li);
        shelf.style.animation = 'none';
        shelf.style.width = '100%';
        shelf.style.justifyContent = 'center';
      });
  });

  /* ---------- Opening hours today highlight ---------- */
  // highlight today's row in the opening hours table (rows run Monday to Sunday)
  var todayIndex = (new Date().getDay() + 6) % 7; // Monday = 0
  var hoursRows = document.querySelectorAll('.hours-table tbody tr');
  if (hoursRows.length === 7) {
    hoursRows[todayIndex].classList.add('today');
  }
  // same highlight for the footer hours list when it runs Monday to Sunday
  document.querySelectorAll('.footer-hours').forEach(function (list) {
    var items = list.querySelectorAll('li');
    if (items.length === 7) items[todayIndex].classList.add('today');
  });

});

// mobile menu toggle
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.menu-toggle');
  var panel = document.getElementById('mobile-nav');
  if (!toggle || !panel) return;
  toggle.addEventListener('click', function () {
    var open = panel.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
});

// cart drawer: AJAX basket that opens from the tote in the header,
// re-rendered client-side from /cart.js after every change
document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var backdrop = document.querySelector('[data-cart-backdrop]');
  if (!drawer || !backdrop) return;

  var itemsBox = drawer.querySelector('[data-cart-items]');
  var emptyBox = drawer.querySelector('[data-cart-empty]');
  var footBox = drawer.querySelector('[data-cart-foot]');
  var closeBtn = drawer.querySelector('[data-cart-close]');
  var lastTrigger = null;
  var busy = false;

  // GBP only: the shop trades in pounds, so a hardcoded pound sign keeps this simple.
  // Multi-currency would need Shopify's money format setting passed in from Liquid.
  function money(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
    });
  }

  // grey out every stepper (drawer and cart page) while a request is in flight
  function setBusy(state) {
    busy = state;
    document.querySelectorAll('[data-qty-minus], [data-qty-plus], [data-qty-input]').forEach(function (el) {
      el.disabled = state;
    });
    document.querySelectorAll('[data-line-remove]').forEach(function (el) {
      el.classList.toggle('is-busy', state);
    });
  }

  function lineRow(item) {
    var row = document.createElement('div');
    row.className = 'cart-line';
    row.setAttribute('data-line-key', item.key);

    if (item.image) {
      var img = document.createElement('img');
      img.className = 'cart-line-img';
      img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      img.alt = item.product_title;
      img.loading = 'lazy';
      img.width = 70;
      img.height = 70;
      row.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'cart-line-img cart-line-img--empty';
      if (window.chaptersAssets && window.chaptersAssets.bookIcon) {
        var phIcon = document.createElement('img');
        phIcon.src = window.chaptersAssets.bookIcon;
        phIcon.alt = '';
        phIcon.setAttribute('aria-hidden', 'true');
        ph.appendChild(phIcon);
      }
      row.appendChild(ph);
    }

    var info = document.createElement('div');
    info.className = 'cart-line-info';

    var title = document.createElement('p');
    title.className = 'cart-line-title';
    var titleLink = document.createElement('a');
    titleLink.href = item.url;
    titleLink.textContent = item.product_title;
    title.appendChild(titleLink);
    info.appendChild(title);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      var variant = document.createElement('p');
      variant.className = 'cart-line-variant';
      variant.textContent = item.variant_title;
      info.appendChild(variant);
    }

    // line item properties, e.g. a gift message (skip Shopify's hidden _ props and blanks)
    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        var val = item.properties[key];
        if (key.charAt(0) === '_' || val === null || String(val).trim() === '') return;
        var prop = document.createElement('p');
        prop.className = 'cart-line-property';
        var label = document.createElement('span');
        label.className = 'cart-line-property-label';
        label.textContent = key + ': ';
        prop.appendChild(label);
        prop.appendChild(document.createTextNode(val));
        info.appendChild(prop);
      });
    }

    var price = document.createElement('p');
    price.className = 'cart-line-price';
    price.setAttribute('data-line-price', '');
    price.textContent = money(item.final_line_price);
    info.appendChild(price);

    var actions = document.createElement('div');
    actions.className = 'cart-line-actions';

    var qty = document.createElement('div');
    qty.className = 'cart-qty';
    var minus = document.createElement('button');
    minus.type = 'button';
    minus.setAttribute('data-qty-minus', '');
    minus.setAttribute('aria-label', 'Decrease quantity');
    minus.textContent = '−';
    var input = document.createElement('input');
    input.type = 'text';
    input.inputMode = 'numeric';
    input.value = item.quantity;
    input.setAttribute('data-qty-input', '');
    input.setAttribute('aria-label', 'Quantity');
    var plus = document.createElement('button');
    plus.type = 'button';
    plus.setAttribute('data-qty-plus', '');
    plus.setAttribute('aria-label', 'Increase quantity');
    plus.textContent = '+';
    qty.appendChild(minus);
    qty.appendChild(input);
    qty.appendChild(plus);
    actions.appendChild(qty);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'cart-line-remove';
    remove.setAttribute('data-line-remove', '');
    remove.textContent = 'Remove';
    actions.appendChild(remove);

    info.appendChild(actions);
    row.appendChild(info);
    return row;
  }

  // keep the cart page in step with the drawer without a full reload
  function syncCartPage(cart) {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    if (cart.item_count === 0) {
      window.location.reload(); // the Liquid template renders the empty state
      return;
    }
    page.querySelectorAll('[data-line-key]').forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      var match = cart.items.find(function (item) { return item.key === key; });
      if (!match) {
        row.remove();
        return;
      }
      var input = row.querySelector('[data-qty-input]');
      if (input) input.value = match.quantity;
      var price = row.querySelector('[data-line-price]');
      if (price) price.textContent = money(match.final_line_price);
    });
  }

  function render(cart) {
    updateCounts(cart.item_count);
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = money(cart.items_subtotal_price);
    });
    var isEmpty = cart.item_count === 0;
    emptyBox.hidden = !isEmpty;
    footBox.hidden = isEmpty;
    itemsBox.replaceChildren();
    cart.items.forEach(function (item) {
      itemsBox.appendChild(lineRow(item));
    });
    syncCartPage(cart);
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(render);
  }

  function openDrawer(trigger) {
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('open');
    backdrop.classList.add('open');
    document.body.classList.add('drawer-open');
    closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    document.body.classList.remove('drawer-open');
    if (lastTrigger) lastTrigger.focus();
    lastTrigger = null;
  }

  function changeLine(key, quantity) {
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(render)
      .catch(function () {})
      .finally(function () { setBusy(false); });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(btn);
      refresh();
    });
  });
  closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });

  // basic focus containment: Tab cycles within the open drawer
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusables = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // quantity steppers and remove, delegated so drawer rows and the cart page share it
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-line-remove]');
    var control = minus || plus || remove;
    if (!control) return;
    var row = control.closest('[data-line-key]');
    if (!row) return;
    if (remove && remove.tagName === 'A') e.preventDefault();
    var quantity = 0;
    if (!remove) {
      var input = row.querySelector('[data-qty-input]');
      quantity = (parseInt(input.value, 10) || 1) + (plus ? 1 : -1);
      if (quantity < 0) quantity = 0;
    }
    changeLine(row.getAttribute('data-line-key'), quantity);
  });

  // typing a quantity directly also posts the change
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-qty-input]')) return;
    var row = e.target.closest('[data-line-key]');
    if (!row) return;
    var quantity = parseInt(e.target.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 1;
    changeLine(row.getAttribute('data-line-key'), quantity);
  });

  // intercept product form adds, then refresh and open the drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return refresh();
      })
      .then(function () { openDrawer(submitBtn); })
      .catch(function () { form.submit(); }) // fall back to the full-page add
      .finally(function () { if (submitBtn) submitBtn.disabled = false; });
  });
});

// product page: thumbnail gallery, variant picker and quantity stepper
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product]').forEach(function (root) {

    // gallery: clicking a thumbnail swaps the main image
    var mainImg = root.querySelector('[data-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = thumb.getAttribute('data-image');
        mainImg.alt = thumb.getAttribute('data-image-alt') || '';
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    // quantity stepper for the buy form, kept separate from the basket steppers
    var qtyInput = root.querySelector('[data-product-qty-input]');
    var qtyMinus = root.querySelector('[data-product-qty-minus]');
    var qtyPlus = root.querySelector('[data-product-qty-plus]');
    function stepQty(delta) {
      if (!qtyInput) return;
      var next = (parseInt(qtyInput.value, 10) || 1) + delta;
      if (next < 1) next = 1;
      qtyInput.value = next;
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function () { stepQty(-1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { stepQty(1); });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var value = parseInt(qtyInput.value, 10);
        qtyInput.value = isNaN(value) || value < 1 ? 1 : value;
      });
    }

    // variant picker: map the selected options to a variant, then update the
    // price, the hidden id input and the buy button availability
    var dataTag = root.querySelector('[data-product-json]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
    if (!dataTag || !selects.length) return;
    var variants;
    try {
      variants = JSON.parse(dataTag.textContent);
    } catch (err) {
      return;
    }
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-product-price]');
    var compareEl = root.querySelector('[data-product-compare]');
    var buyBtn = root.querySelector('[data-buy-button]');

    // GBP only, matching the cart drawer's hardcoded pound sign
    function money(pence) {
      return '£' + (pence / 100).toFixed(2);
    }

    function update() {
      var variant = variants.find(function (v) {
        return selects.every(function (sel, i) { return v.options[i] === sel.value; });
      });
      if (!variant) {
        if (buyBtn) {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.getAttribute('data-label-sold-out');
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (buyBtn) {
        if (buyBtn.hasAttribute('data-locked')) {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.getAttribute('data-label-locked') || buyBtn.getAttribute('data-label-sold-out');
        } else {
          buyBtn.disabled = !variant.available;
          buyBtn.textContent = variant.available
            ? buyBtn.getAttribute('data-label-add')
            : buyBtn.getAttribute('data-label-sold-out');
        }
      }
    }

    selects.forEach(function (sel) { sel.addEventListener('change', update); });
    update();
  });
});

// form builder: AJAX submit to Formspree, then redirect or show an inline message
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fb-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var status = form.querySelector('.fb-status');

      // required checkbox groups need at least one box ticked
      var badGroup = null;
      form.querySelectorAll('fieldset[data-group-required]').forEach(function (fs) {
        if (!badGroup && !fs.hidden && !fs.querySelector('input:checked')) badGroup = fs;
      });
      if (badGroup) {
        var legend = badGroup.querySelector('legend');
        status.textContent = 'Please tick at least one option for "' + (legend ? legend.textContent.replace('*', '').trim() : 'the required choices') + '".';
        status.classList.remove('fb-status-success');
        status.classList.add('fb-status-error');
        status.hidden = false;
        var first = badGroup.querySelector('input');
        if (first) first.focus();
        return;
      }
      status.hidden = true;

      btn.disabled = true;
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          var redirect = form.getAttribute('data-redirect');
          if (redirect) {
            window.location.assign(redirect);
            return;
          }
          form.querySelectorAll('.fb-field, .fb-choices, .fb-note, .fb-actions').forEach(function (el) { el.hidden = true; });
          status.textContent = form.getAttribute('data-success');
          status.classList.add('fb-status-success');
          status.hidden = false;
        })
        .catch(function () {
          btn.disabled = false;
          status.textContent = form.getAttribute('data-error');
          status.classList.add('fb-status-error');
          status.hidden = false;
        });
    });
  });
});

// conditional form fields: show a field only when a named answer matches
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fb-form').forEach(function (form) {
    var conds = form.querySelectorAll('[data-cond-field]');
    if (!conds.length) return;
    function update() {
      conds.forEach(function (el) {
        var name = el.getAttribute('data-cond-field');
        var want = (el.getAttribute('data-cond-value') || '').trim().toLowerCase();
        var val = '';
        var checked = form.querySelector('[name="' + name + '"]:checked');
        if (checked) {
          val = checked.value;
        } else {
          var field = form.querySelector('select[name="' + name + '"], input[name="' + name + '"]:not([type="radio"])');
          if (field) val = field.value;
        }
        var show = val.trim().toLowerCase() === want;
        if (!show && !el.hidden) {
          el.querySelectorAll('input, textarea, select').forEach(function (i) { i.value = ''; });
        }
        el.hidden = !show;
      });
    }
    form.addEventListener('change', update);
    update();
  });
});

// Kit (ConvertKit) newsletter forms: post straight to Kit via AJAX, keep our styling
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form.kit-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var hp = form.querySelector('.fn-hp');
      if (hp && hp.value) return; // honeypot tripped
      var btn = form.querySelector('button[type="submit"]');
      var status = form.querySelector('.fn-status');
      if (btn) btn.disabled = true;
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          form.querySelectorAll('label, input, button').forEach(function (el) { el.style.display = 'none'; });
          status.textContent = form.getAttribute('data-success') || 'Thanks for subscribing.';
          status.hidden = false;
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          status.textContent = 'Something went wrong. Please try again.';
          status.hidden = false;
        });
    });
  });
});

// short description: clamp long summaries and reveal the rest on click.
// Starts unclamped so no-JS visitors always see the full text; the toggle
// only appears when the text is actually taller than the collapsed height.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-short.is-collapsible').forEach(function (box) {
    var text = box.querySelector('.product-short-text');
    var toggle = box.querySelector('.product-short-toggle');
    if (!text || !toggle) return;

    box.classList.add('is-collapsed');
    if (text.scrollHeight <= text.clientHeight + 2) {
      // fits within the collapsed height, no need to clamp or offer a toggle
      box.classList.remove('is-collapsed');
      return;
    }
    toggle.hidden = false;

    toggle.addEventListener('click', function () {
      var collapsed = box.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      toggle.textContent = collapsed ? 'Read More' : 'Read Less';
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Footer: collapse the accordion columns on mobile ---------- */
  // Columns render with the open attribute so they work without JS. On mobile
  // we collapse them into tap-to-open accordions; on desktop they stay open.
  var accs = document.querySelectorAll('.footer-acc');
  if (!accs.length) return;
  var mq = window.matchMedia('(max-width: 700px)');
  function sync() {
    accs.forEach(function (d) { d.open = !mq.matches; });
  }
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
});

document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Live open / closed status ---------- */
  // Reads today's hours from the footer list (single source of truth) and works
  // out the status in Chester time, so it's right whatever timezone the visitor is in.
  var el = document.querySelector('[data-open-status]');
  if (!el) return;

  var rows = document.querySelectorAll('.footer-hours li');
  if (rows.length !== 7) return; // leave the static fallback text in place

  var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  function parseTime(str) {
    var m = str.match(/(\d{1,2})(?:[.:](\d{2}))?\s*(am|pm)/i);
    if (!m) return null;
    var h = parseInt(m[1], 10);
    var min = m[2] ? parseInt(m[2], 10) : 0;
    var pm = /pm/i.test(m[3]);
    if (pm && h < 12) h += 12;
    if (!pm && h === 12) h = 0;
    return h * 60 + min;
  }

  function fmt(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    var ap = h < 12 ? 'am' : 'pm';
    var hh = h % 12; if (hh === 0) hh = 12;
    return hh + (m ? '.' + (m < 10 ? '0' + m : m) : '') + ap;
  }

  var schedule = [];
  for (var i = 0; i < 7; i++) {
    var cell = rows[i].querySelectorAll('span')[1];
    var txt = cell ? cell.textContent.trim() : '';
    var dash = txt.split(/\s[-–—]\s/);
    var o = dash.length === 2 ? parseTime(dash[0]) : null;
    var c = dash.length === 2 ? parseTime(dash[1]) : null;
    schedule.push((o != null && c != null) ? { open: o, close: c } : null);
  }

  // current weekday + time in Chester, independent of the visitor's own clock
  var parts;
  try {
    parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', weekday: 'long', hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date());
  } catch (e) { return; }
  var wd = '', hr = 0, mn = 0;
  parts.forEach(function (p) {
    if (p.type === 'weekday') wd = p.value;
    else if (p.type === 'hour') hr = parseInt(p.value, 10);
    else if (p.type === 'minute') mn = parseInt(p.value, 10);
  });
  if (hr === 24) hr = 0;
  var day = days.indexOf(wd);
  if (day < 0) return;
  var nowMin = hr * 60 + mn;

  var state = 'is-closed', text = 'Closed';
  var todayH = schedule[day];
  if (todayH && nowMin >= todayH.open && nowMin < todayH.close) {
    if (todayH.close - nowMin <= 30) { state = 'is-soon'; text = 'Closing soon · ' + fmt(todayH.close); }
    else { state = 'is-open'; text = 'Open now · until ' + fmt(todayH.close); }
  } else if (todayH && nowMin < todayH.open) {
    text = 'Closed · opens ' + fmt(todayH.open);
  } else {
    for (var j = 1; j <= 7; j++) {
      var d = (day + j) % 7;
      if (schedule[d]) {
        text = 'Closed · opens ' + (j === 1 ? 'tomorrow' : days[d]) + ' ' + fmt(schedule[d].open);
        break;
      }
    }
  }

  el.textContent = text;
  el.classList.remove('is-open', 'is-soon', 'is-closed');
  el.classList.add(state);
});
